import React, { Component } from "react";
import { Link } from "react-router-dom";

//import Header from "../component/Header";
import HeaderAudioBook from "../component/HeaderAudioBook";
import BottomNavAudioBook from "../component/BottomNavAudioBook";

import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Grid from "@material-ui/core/Grid";
import Checkbox from "@material-ui/core/Checkbox";
import Button from "@material-ui/core/Button";
import SearchOutlinedIcon from "@material-ui/icons/SearchOutlined";

import SearchBookList from "../component/SearchBookList";
import BookListViewByAuthor from './BookListViewByAuthor';

import cookie from 'react-cookie';

import ReactGA from 'react-ga';
ReactGA.initialize('UA-125086411-4');

class CateView2AudioBook extends Component {
	state = {
		headerTitle: "더책",
		query: "",
		loading: false,
		data: [],
		booklist: [
			{
				'title': '전체',
				'sw': '',
				"ow": 0,
				"ob": 0,
				"al": '',
				"st": 40,
				"lg": 0
			},
			{
				'title': '연령별:영유아',
				'sw': '',
				"ow": 0,
				"ob": 0,
				"al": '10|20',
				"st": 40,
				"lg": 0
			},
			{
				'title': '연령별:초등',
				'sw': '',
				"ow": 0,
				"ob": 0,
				"al": '30|40',
				"st": 40,
				"lg": 0
			},
			{
				'title': '연령별:중/고등학교',
				'sw': '',
				"ow": 0,
				"ob": 0,
				"al": '50|60',
				"st": 40,
				"lg": 0
			},
			{
				'title': '연령별:성인',
				'sw': '',
				"ow": 0,
				"ob": 0,
				"al": '70',
				"st": 40,
				"lg": 0
			},
			/*{
				'title': '더책 가능 도서',
				'sw': '',
				"ow": 0,
				"ob": 0,
				"al": '',
                "st": 40,
                "lg": 0
            },*/
            {
                'title': '영어도서',
                'sw': '',
                "ow": 0,
                "ob": 0,
                "al": '',
                "st": 40,
                "lg": 20
            }
		]
	};

	constructor(props) {
		super(props);



	}

	//getData = (strquery) => {

	//	console.log("aaa: " + strquery + ", " + this.prevState);

	//	fetch(`api/AB/AuthorList?pgidx=0&pgsize=50000&orderby=1&orderway=1&search=${strquery}`)
	//		.then(response => response.json())
	//		.then(data => {
	//			//alert(JSON.stringify(data));
	//			console.log(JSON.stringify(data));
	//			const { query } = this.state;
	//			const booklist = data.lstresult;

	//			this.setState({
	//				data,
	//				booklist
	//			});
 //           });
 //       ReactGA.event({ category: "검색어", action : strquery });
	//};

	//componentWillMount() {
	//	//this.getData('');
	//}

    logPageView() {
        ReactGA.set({ page: window.location.pathname });
        ReactGA.pageview(window.location + "&orgid=" + cookie.load("orgid"));
    }

    render() {
        this.logPageView();

		//let contents = this.state.loading === true ? "loading..." : this.dorender();
		let contents = "loading...";

		return (
			<React.Fragment>
				<HeaderAudioBook headerTitle={this.state.headerTitle} />

                <div >
                <div ref="toptitle" style={{marginBottom: '-10px'}}  >
                 <br/><p/>
                <center>
                <h3> 전체 보기 </h3>
                </center>
                </div>
				<div className="section-body">
					<React.Fragment>
						<ul className="bookList">
							{this.state.booklist.map((book, index) => {
								return (
									<React.Fragment>
                                        <li className="bookList-item">
											<Link to={{
												pathname: `/BookList2AudioBook`,
												state: {
													sw: book.sw,
													ow: book.ow,
													ob: book.ob,
													al: book.al,
													    st: book.st,
													    lg:book.lg,
													subtitle: book.title
												}
											}}>
												<div className="bookList-info">
                                                    <h3 className="bookList-title">
                                                            {book.title}
                                                    </h3>
												</div>
                                                </Link>
										</li>
									</React.Fragment>
								);
							})}

							<React.Fragment>
                                <li className="bookList-item">
									<Link to={{
										pathname: `/svpublisher_audiobook`
									}}>
										<div className="bookList-info">
                                            <h3 className="bookList-title">
                                                    출판사별
                                                    </h3>
										</div>
									</Link>
								</li>
							</React.Fragment>

							<React.Fragment>
								<li className="bookList-item">
									<Link to={{
										pathname: `/svauthor_audiobook`
									}}>
										<div className="bookList-info">
                                            <h3 className="bookList-title">
                                                    저자별
                                                </h3>
										</div>
									</Link>
								</li>
							</React.Fragment>
						</ul>
					</React.Fragment>
					
				</div>
				</div>
                <BottomNavAudioBook />
			</React.Fragment>
		);
	}
}

export default CateView2AudioBook;
